import { Component, Input } from '@angular/core';
import { LandingPageSection } from 'src/app/landing-page.model';

@Component({
  selector: 'app-page-service',
  templateUrl: './page-service.component.html',
  styleUrls: ['./page-service.component.scss']
})
export class PageServiceComponent {
  @Input() data: LandingPageSection;
  @Input() desktopWidth: string = "1110";
  constructor() { }

}
